<div class="oiq-notification-event-list">
  @for (row of items; track row.id) {
    <div class="item border-dark-50 rounded border shadow">
      <span class="material-symbols-outlined">calendar_today</span>
      <div class="notification mx-2">
        <div (click)="event.next({ type: 'edit', data: row })">
          @if (row.entityName) {
            <span>{{ row.entityType }}</span>
          }
          @if (!row.entityName) {
            <span>Calendar</span> Event
          }
        </div>
        <div class="small text-dark">
          <div (click)="event.next({ type: 'edit', data: row })">
            {{ row.title }}
          </div>
          @if (row.entityName && row.entityType && row.entityId) {
            <a
              routerLink="/{{ row.entityType }}/{{ row.entityId }}/{{
                row.entityType == 'law-firms' || row.entityType == 'isos'
                  ? 'general-info'
                  : 'overview'
              }}"
              (click)="event.next({ type: 'show', data: row })">
              {{ row.entityName }}
            </a>
          }
        </div>
      </div>
      <span class="datetime small d-flex flex-column">
        <div class="text-right">
          <strong>{{ getFormatFromNow(row.eventDate) }}</strong>
        </div>
        <button
          class="oiq-button oiq-button--primary--link oiq-button--sm -mr-6 ms-auto mt-1"
          (click)="event.next({ type: 'delete', data: row })"
          [disabled]="this.isDeleting">
          <span>Delete</span>
          <span class="material-symbols-outlined font-xs">delete</span>
        </button>
      </span>
      <span class="status" [class.new]="!row.eventRead"></span>
    </div>
  }
</div>
